import { ShareSearchType } from "@zapier/bff";
import { trpc } from "../trpc";
import { keepPreviousData } from "@tanstack/react-query";

interface TableShareUser {
  id: string;
  name: string;
  email?: string;
  avatarUrl?: string;
  isOwner: boolean;
  hasLoggedIn: boolean;
  isDisabled: boolean;
}

interface UseTableSharesSearchOptions {
  tableId: string;
  ownerId?: number | string;
  search?: string | null;
  type?: ShareSearchType;
}

// the share subject is in the format of "account_id:2074697,customuser_id:9405721"
export const extractCustomUserId = (subject: string): string => {
  return subject.includes("customuser_id:")
    ? subject.slice(subject.indexOf("customuser_id:") + "customuser_id:".length)
    : subject;
};

// Returns a list of users, teams, and accounts that can be shared with this table.
export function useTableSharesSearch({
  tableId,
  ownerId,
  search = "",
  type = "customuser",
}: UseTableSharesSearchOptions) {
  const { data, isLoading, isError, error } = trpc.table.shareSearch.useQuery(
    { tableId: tableId || "", search: search || "", type: type },
    {
      enabled: !!tableId,
      placeholderData: keepPreviousData,
    },
  );

  const users: TableShareUser[] = (data?.data || []).map((share) => {
    const customUserId = extractCustomUserId(share.subject);
    const isOwner = customUserId === ownerId?.toString();

    return {
      id: share.subject,
      name: share.name || "",
      email: share?.detail,
      photoUrl: share?.avatarUrl,
      isOwner,
      hasLoggedIn: !!share?.hasLoggedIn,
      isDisabled: isOwner || !share.hasLoggedIn,
    };
  });

  return {
    users,
    isLoading,
    isError,
    error,
  };
}
